/**
 *
 * All regestered route for sidebar only.
 *
 */

import Dashboard from "views/Dashboard.js";
import Agenda from 'views/Agenda/Agenda.js';
import AuditIndex from 'views/Audit/Auditor/Index.js';
import Document from 'views/Document/Document.js';

const layout = {
  layout: '/auditor',
  user: true,
};

/** Only handle authenticated user */
var routes = [
  {
    path: "/dashboard",
    ...layout,
    name: "Dashboard",
    icon: "nc-icon nc-chart-pie-35",
    component: Dashboard,
  },
  {
    path: "/audits",
    name: "Audit",
    ...layout,
    icon: "nc-icon nc-notes",
    component: AuditIndex,
  },
  {
    path: "/agenda",
    layout: "/auditor",
    name: "Agenda",
    state: "openTables",
    icon: "nc-icon nc-paper-2",
    component: Agenda,
  },
  {
    path: "/document",
    ...layout,
    name: "Document",
    icon: "nc-icon nc-single-copy-04",
    component: Document,
  },
];

export default routes;
